import EventEmitter from 'eventemitter3';
import Dispatcher from '../core/Dispatcher';
import ActionTypes from '../constants/ActionTypes';
import Location from '../core/Location';
import GalleryStore from './Gallery';

var CHANGE_EVENT = 'change';

var _state = {
  loading: {
    enabled: false,
    message: ''
  },
  steps: {
    uploadData: null,
    uploadPath: null,
    uploadId: null,
    error: false,
    errorMessage: null,
    height: '5'
  },
  gallery: GalleryStore.get()
}

class GlobalStore extends EventEmitter {
  constructor(params) {
    super(params);
    this._updateGallery = this._updateGallery.bind(this);

    GalleryStore.addChangeListener(this._updateGallery);
  }

  _updateGallery() {
    _state.gallery = GalleryStore.get();
    this.emitChange();
  }

  emitChange() {
    this.emit(CHANGE_EVENT);
  }

  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  }

  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  }

  get() {
    return _state;
  }
}

var globalStore = new GlobalStore();
globalStore.dispatchToken = Dispatcher.register(function(action) {
  switch (action.type) {
    case ActionTypes.STEP_UPLOAD: {
      _state.loading.enabled = true;
      _state.loading.message = 'Uploading and optimizing SVG...';

      globalStore.emitChange();

      $.ajax({
        type: 'POST',
        url: '/api/upload',
        data: _state.steps.uploadData,
        processData: false,
        contentType: false,
      })
      .success(function(data) {
        _state.steps.error = false;
        _state.loading.enabled = false;
        Location.pushState(null, '/convert/' + data.id);
      })
      .error(function(xhr, status, err) {
        var message = (xhr.responseJSON) ? xhr.responseJSON.error : 'Server Error, please try again later.';
        _state.loading.enabled = false;
        _state.steps.error = true;
        _state.steps.errorMessage = message;

        globalStore.emitChange();
      });

    } break;

    case ActionTypes.STEP_DOWNLOAD: {
      $.get({url: '/api/download/' + action.id});
    } break;

    case ActionTypes.STEP_CONVERT: {
      _state.loading.enabled = true;
      _state.loading.message = 'Converting to STL...';

      globalStore.emitChange();

      var data = {
        'height': _state.steps.height,
        'uploadId': _state.steps.uploadId
      };

      $.ajax({
        type: 'POST',
        url: '/api/convert',
        data: data
      })
      .success(function(data) {
        _state.steps.error = false;
        _state.loading.enabled = false;

        Location.pushState(null, '/download/' + data.id);
      })
      .error(function(xhr, status, err) {
        _state.loading.enabled = false;

        switch(xhr.status) {
          case 400:
          case 500: {
            _state.steps.error = true;
            _state.steps.errorMessage = xhr.responseJSON.error;
          } break;
        }

        globalStore.emitChange();
      });

    } break;

    case ActionTypes.STEP_SET_HEIGHT: {
      var error = 'The height must be a decimal between 0 and 300.'
      _state.steps.height = action.height;

      if(isNaN(action.height) || action.height == '') {
        _state.steps.error = true;
        _state.steps.errorMessage = error;
      }
      else {
        if(parseFloat(action.height) <= 0 || parseFloat(action.height) > 300) {
          _state.steps.error = true;
          _state.steps.errorMessage = error;
        }
        else {
          _state.steps.error = false;
        }
      }

      globalStore.emitChange();
    }

    case ActionTypes.STEP_SET_UPLOAD_ID: {
      _state.steps.uploadId = action.id;
      globalStore.emitChange();
    } break;

    case ActionTypes.STEP_SET_UPLOAD_DATA: {
      _state.steps.error = false;
      _state.steps.uploadData = action.data;
      _state.steps.uploadPath = action.path;
      globalStore.emitChange();
    } break;

    case ActionTypes.SPINNER_START: {
      _state.loading.enabled = true;
      _state.loading.message = action.message;
      globalStore.emitChange();
    } break;

    case ActionTypes.SPINNER_STOP: {
      _state.loading.enabled = false;
      globalStore.emitChange();
    } break;

    default:
      // do nothing
  }
});

export default globalStore;



/** WEBPACK FOOTER **
 ** ./src/stores/Global.js
 **/